// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
// import Variable from './ckeditor5-variable/src/variable';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';

// import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';     // <--- ADDED

export default class DecoupledEditor extends ClassicEditorBase {
  constructor(sourceElementOrData, config) {
    super(sourceElementOrData, config);
    console.log(sourceElementOrData, config)
  }
}

// Plugins to include in the build.
DecoupledEditor.builtinPlugins = [
  Essentials,
  Bold,
  Italic,
  Underline,
  // Mention,
  // Variable,
  // Link,
  Paragraph,
  // Alignment                                                            // <--- ADDED
];

// Editor configuration.
DecoupledEditor.defaultConfig = {
  toolbar: ['bold', 'italic', 'underline'],
  language: 'en'
};
